import React from "react";

import CSSModules from "lib/utils/css-modules";
import st from "lib/utils/index";
import { Link, Button } from "lib/components/vendor";
import BalanceStatusLabel from "lib/components/BalanceStatusLabel";
import OrderStatusLabel from "lib/components/OrderStatusLabel";
import styles from "./CustomersListItem.less";

@CSSModules(styles)
export default class CustomersListItem extends React.PureComponent {
  render() {
    const { customer } = this.props;

    const getCustomersCompanyId = () => {
      if (customer && customer.companies.length > 0) {
        const lastCustomerCompanyIndex = customer.companies.length - 1;
        return customer.companies.length > 1 ? customer.companies[lastCustomerCompanyIndex].id : customer.companies[0].id;
      }
      return null;
    };
    const customersCompanyId = getCustomersCompanyId();

    return (
      <Link as="a" to={`/c/${customersCompanyId}/customers/${customer.id}`} styleName="item">
        <div styleName="item-image">
          <img src="/images/placeholder-user.png" />
        </div>
        <div styleName="item-content">
          <div styleName="item-title">
            <div styleName="item-title-customer_name">{customer.full_name}</div>
          </div>
          <div styleName="item-metas">
            {!!customer.phone_number && (
              <div styleName="item-meta">
                <span className="with-icon">
                  <i className="icon material-icons">phone</i>
                  <span className="text">{customer.phone_number}</span>
                </span>
              </div>
            )}
            {!!customer.email && (
              <div styleName="item-meta">
                <span className="with-icon">
                  <i className="icon material-icons">email</i>
                  <span className="text">{customer.email}</span>
                </span>
              </div>
            )}
          </div>
        </div>
        <div styleName="item-read-more-button">
          <i className="icon material-icons">chevron_right</i>
        </div>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/list/CustomersListItem.jsx